import React from 'react'
import { linkResolver } from './linkResolver'

export const repositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_MAIN_REPOSITORY_NAME,
    linkResolver,
    componentResolver: {
      blog: React.lazy(() => import('../templates/blog')),
      blogpost: React.lazy(() => import('../templates/blogpost')),
      carpark: React.lazy(() => import('../templates/carPark')),
      hotel: React.lazy(() => import('../templates/hotel')),
      page: React.lazy(() => import('../templates/page'))
    }
  }
]
